import { DexQueryEnumType } from '@mark43/cad-api';
import { DexQuerySubmission } from '@mark43/dex-api';
import { UseFormReturn } from 'react-hook-form';
import { WebDisMetadata } from '@m43/core';
import { useBootstrapState } from '../../bootstrap/bootstrap-provider';
import { useApplicationType } from '../../common/hooks/use-application-type';
import { useUnitAssignment } from '../../unit-assignment/unit-assignment-context';
import { DexFormModel } from '../types';
import { useDexMetadata } from '../use-dex-metadata';
import { stripEmptyStringsAndTrim } from '../utils';
import { useIsLinkToAssignedEventCheckboxVisible } from './use-is-link-to-assigned-even-visible';
import { ElectronDexMetadata } from '../../electron-bridge/electron-bridge';
import { useGetDexQuerySpecificValues } from './use-get-dex-query-specific-values';

export function useBuildDexQuerySubmission(
    form: UseFormReturn<DexFormModel<any>>,
    dexQuery: DexQueryEnumType
) {
    const { isFirstResponder } = useApplicationType();
    const { dexMetadata } = useDexMetadata();

    const { userProfileView } = useBootstrapState();
    const isLinkToAssignedEventCheckboxVisible = useIsLinkToAssignedEventCheckboxVisible();
    const unitAssignment = useUnitAssignment();
    const dexQuerySpecificValues = useGetDexQuerySpecificValues(form);
    return (formModel: DexFormModel<any>): DexQuerySubmission => {
        return {
            params: stripEmptyStringsAndTrim({ ...formModel.params, ...dexQuerySpecificValues }),
            dexQuery,
            deviceName:
                (dexMetadata as ElectronDexMetadata)?.deviceName ||
                (dexMetadata as WebDisMetadata)?.machineName,
            dexStateUserId: userProfileView.dexStateUserId,
            requestingUnitId: isFirstResponder
                ? unitAssignment?.unitId
                : formModel.requestingUnitOption?.value,
            oriAliasId: formModel.oriAliasId,
            isRunByUnit: isFirstResponder,
            linkToAssignedEvent: isLinkToAssignedEventCheckboxVisible
                ? formModel.linkToAssignedEvent
                : undefined,
            agencyEventId: isFirstResponder ? undefined : formModel.agencyEventOption?.value,
            dataExchangeEntryPoint: isFirstResponder
                ? 'CAD_FIRST_RESPONDER_FORM'
                : 'CAD_DISPATCH_FORM',
        };
    };
}
